// @flow

import React, { Component } from "react";
import NumberEasing from "react-number-easing";
import DocumentTitle from "react-document-title";

import styled from "styled-components";
import {
  AppTitle,
  AppSubtitle,
  SectionTitle,
  SplitContainer,
  SplitChild,
  colors
} from "../styles";
import InputField from "../InputField";
import A from "../A";
import inputText from "./inputText";

const Doughnut = require("react-chartjs").Doughnut;

export default class Calculator extends Component {
  _updateField = (id: string, value: number) =>
    this.setState(oldState => ({
      values: { ...oldState.values, [id]: value }
    }));
  state = {
    values: {
      "work-income": 0,
      "401k-match": 0,
      "other-income": 0,

      "other-retirement": 0,
      "taxable-savings": 0,
      "home-equity": 0,
      debt: 0,

      "net-worth": 0
    }
  };

  _sumVals(keys: Array<string>) {
    return keys.reduce((sum, key) => this.state.values[key] + sum, 0);
  }

  _renderInput(inputKey: string) {
    return (
      <InputField
        id={inputKey}
        label={inputText[inputKey].label}
        helpText={inputText[inputKey].helpText}
        onUpdate={this._updateField}
        values={this.state.values}
      />
    );
  }

  render() {
    const income = this._sumVals(["work-income", "401k-match", "other-income"]);
    const savings = this._sumVals([
      "401k-match",
      "other-retirement",
      "taxable-savings",
      "home-equity",
      "debt"
    ]);
    const savingsRate = income === 0 ? 0 : Math.round(savings / income * 100);

    return (
      <div className="container">
        <DocumentTitle title="Savings Rate Calculator | OneNumberUp" />
        <div className="App-header">
          <AppTitle>Savings Rate Calculator</AppTitle>
          <AppSubtitle>
            Your savings rate is the{" "}
            <A href="http://www.mrmoneymustache.com/2012/01/13/the-shockingly-simple-math-behind-early-retirement/">
              one number
            </A>{" "}
            you need to
            know to determine how long you have left before retirement.
            Calculate yours in just 90 seconds!
          </AppSubtitle>
        </div>
        <SplitContainer>
          <SplitChild narrow>
            <SectionTitle>Income</SectionTitle>
            {this._renderInput("work-income")}
            {this._renderInput("401k-match")}
            {this._renderInput("other-income")}
            <SectionTitle>Savings</SectionTitle>
            {this._renderInput("401k-match")}
            {this._renderInput("other-retirement")}
            {this._renderInput("taxable-savings")}
            {this._renderInput("home-equity")}
            {this._renderInput("debt")}
          </SplitChild>
          <SplitChild>
            <SectionTitle centered>
              Your Savings Rate
            </SectionTitle>
            <SavingsCalc>
              <div className="fraction">
                <div className="top">
                  <span className="fraction-label">Savings:</span>${Math.round(savings)}
                </div>
                <div>
                  <span className="fraction-label">Income:</span>${Math.round(income)}
                </div>
              </div>
              &nbsp;✕ 100 =&nbsp;
              <span className="savings-number">
                <NumberEasing value={savingsRate} speed={1000} />%
              </span>
            </SavingsCalc>
            <Doughnut
              data={[
                {
                  color: colors.grey,
                  value: savings === 0 ? 1 : income - savings
                },
                { color: colors.green, value: savings }
              ]}
              options={{
                legend: { position: "top" }
              }}
            />

            <SectionTitle className="centered">
              Learn More
            </SectionTitle>
            <div>
              We're launching an email course and savings rate tracker so you
              can compare your savings month-to-month. If you'd like to be the
              first to know when it's available,{" "}
              <A href="http://eepurl.com/cWHrnL">
                sign up now
              </A>!
            </div>
          </SplitChild>
        </SplitContainer>
      </div>
    );
  }
}

const SavingsCalc = styled.div`
  font-size: 2em;
  display: flex;
  align-items: center;
  margin-bottom: 40px;

  .fraction {
    > div {
      padding: 15px 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .top {
      border-bottom: 1px solid #333;
    }

    .fraction-label {
      font-size: 0.5em;
      color: #888;
      padding-right: 1em;
    }
  }

  .savings-number {
    font-weight: bold;
    color: ${colors.green}
  }
`;



// WEBPACK FOOTER //
// ./src/calc/index.js